import { HeaderLabelChipStyle } from '@tableau/catalog-ui-temp';
import React from 'react';

import { LabelWrapper } from '~src/catalog/CatalogLabelsHookHelper';
import { ModifiedDateMetadata, OwnerMetadata } from '~src/spacesPlatform/components/header/HeaderMetadataRow';
import { ActionsMenuIcon, FavoriteToggleWithCountsIcon } from '~src/spacesPlatform/components/header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/spacesPlatform/components/header/SpaceHeader';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

import { SiteUrlsProps } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { ConnectedExtractMetadata } from '../../extractTask/components/spaces/header/ExtractMetadata';
import { EditFlowEntityAction } from '../entityActions/EditFlowEntityAction';
import { FlowAllowedActions } from '../serverApi/types/FlowAllowedActions';
import { FlowSpaceBanner } from './FlowSpaceBanner';

export interface FlowSpaceHeaderProps extends SiteUrlsProps {
  readonly item: ISpaceItemDetailInfo<'flow'>;
  readonly availableActions: FlowAllowedActions;
  readonly catalogingOnSiteEnabled: boolean;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}

export function FlowSpaceHeader(props: FlowSpaceHeaderProps): JSX.Element {
  const shouldShowDraftBanner = props.item && props.item.flowDraft;

  return <ConnectedSpaceHeader
    item={props.item}
    availableActions={props.availableActions}
    nameRowIcons={
      <React.Fragment>
        {FavoriteToggleWithCountsIcon({
          item: props.item,
          addToFavorites: props.addToFavorites,
          removeFromFavorites: props.removeFromFavorites,
        })}
        {ActionsMenuIcon(props.item)}
      </React.Fragment>
    }
    metadataRow={
      <React.Fragment>
        {OwnerMetadata(props.item.owner, props.urls)}
        {ModifiedDateMetadata(props.item.updatedAt)}
        <ConnectedExtractMetadata itemInfo={props.item} availableActions={props.availableActions} />
        <div style={{marginLeft: '24px'}}>
          <LabelWrapper itemInfo={props.item} isEager={true} kind={'chip'}
            wrapper={(e) =><HeaderLabelChipStyle>{e}</HeaderLabelChipStyle>}/>
        </div>
      </React.Fragment>
    }
    spotlightActions={shouldShowDraftBanner ? [] : [EditFlowEntityAction]}
    bottomElement={<FlowSpaceBanner item={props.item} />}
  />;
}
